/**------------------------------------------------------
 * Enums
 */
export enum EnumApiTokenCostRoute {
	DescribeImage 		= '/ai-image-editor/create-job/describe',
	GenerateImages 		= '/ai-image-editor/create-job/generate',
	RemixImage 			= '/ai-image-editor/create-job/remix',
	RemoveBackground	= '/ai-image-editor/create-job/remove-background',
	UpscaleImage		= '/ai-image-editor/create-job/upscale',
	ListingByVision		= '/ai-listing/vision',
	FlaiAgent			= '/ai-listing/flai',
	MbaSetupByVision	= '/ai-listing/mba-setup',
	ListingByKeywords	= '/ai-listing/keywords',
	ListingByTemplate	= '/ai-listing/template',
	AgentExplain		= '/agent/explain-function'
}


/**------------------------------------------------------
 * Interfaces
 */
export interface IApiTokenCostConfigEntry<TOptions extends object = object, TApiTokenCosts extends object = object> {
	name					: string;
	description				: string;
	reasonText				: string;
	apiTokenCosts			: TApiTokenCosts;
	costCalculateFunction	: (options: TOptions) => number;
}
